if (!customElements.get('quotes-section')) {
  class QuotesSection extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.id;
      this.selectors = {
        logos: `.quotes__logos-slideshow-${this.sectionId}`,
        content: `.quotes__content-slideshow-${this.sectionId}`
      };
      this.logosSlideshowContainer = this.querySelector(this.selectors.logos);
      this.contentSlideshowContainer = this.querySelector(this.selectors.content);

      this.configsSlideshow = {
        logos: {
          infinite: false,
          asNavFor: this.selectors.content,
          slidesToScroll: 1,
          slidesToShow: 5,
          focusOnSelect: true
        },
        content: {
          infinite: false,
          asNavFor: this.selectors.logos,
          slidesToScroll: 1,
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          fade: true
        }
      }

      if (!this.logosSlideshowContainer || !this.contentSlideshowContainer) return;

      this.$logosSlideshow = $(this.logosSlideshowContainer).slick(this.configsSlideshow.logos);
      this.$contentSlideshow = $(this.contentSlideshowContainer).slick(this.configsSlideshow.content);

      console.log(this.$contentSlideshow);
      console.log(this.$logosSlideshow);
    }
  }

  customElements.define('quotes-section', QuotesSection);
}
